import { useState } from "react";
import { FaSearch } from "react-icons/fa"; // ícone da lupa
import styles from "./Search.module.css";

function Search({ onSetFiltroTexto, noBorder }) {
  const [filtroTexto, setFiltroTexto] = useState("");

  const handleChange = (e) => {
    const valor = e.target.value;
    setFiltroTexto(valor);
    if (onSetFiltroTexto) {
      onSetFiltroTexto(valor);
    }
  };

  return (
    <div className={styles.divpesquisa}>
      <FaSearch className={styles.icon} /> {/* ícone da lupa */}
      <input
        type="text"
        id="search_input"
        placeholder="Digite aqui o que procura..."
        className={`${styles.search_input} ${noBorder ? styles.semBorda : ''}`}
        value={filtroTexto}
        onChange={handleChange}
      />
    </div>
  );
}

export default Search;
